(() => {
  if (customElements.get('phm-life-carousel')) return;

  customElements.define('phm-life-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._cleanup) return;
      const track = this.querySelector('[data-story-track]');
      if (!track) return;
      const slides = [...track.children];
      const topics = [...this.querySelectorAll('[data-story-go]')];
      const steps = [...this.querySelectorAll('[data-story-step]')];
      const status = this.querySelector('[data-story-status]');
      let current = 0;
      let timer;
      const update = () => {
        current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        topics.forEach((button, index) => button.setAttribute('aria-pressed', String(index === current)));
        steps.forEach(button => {
          button.disabled = Number(button.dataset.storyStep) < 0 ? current === 0 : current === slides.length - 1;
        });
        status.textContent = `${current + 1} / ${slides.length} · ${topics[current].textContent.trim()}`;
      };
      const go = index => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({left: target * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      const onClick = event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-story-go')) go(Number(button.dataset.storyGo));
        if (button.hasAttribute('data-story-step')) go(current + Number(button.dataset.storyStep));
      };
      const onKey = event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowLeft' ? -1 : 1));
      };
      const onScroll = () => {
        clearTimeout(timer);
        timer = setTimeout(update, 100);
      };
      let previousWidth = track.clientWidth;
      const resize = new ResizeObserver(() => {
        if (track.clientWidth === previousWidth) return;
        previousWidth = track.clientWidth;
        track.scrollTo({left: current * previousWidth, behavior: 'instant'});
      });
      resize.observe(track);
      this.addEventListener('click', onClick);
      track.addEventListener('keydown', onKey);
      track.addEventListener('scroll', onScroll, {passive: true});
      this.querySelectorAll('[data-story-controls]').forEach(control => { control.hidden = false; });
      update();
      this._cleanup = () => {
        clearTimeout(timer);
        resize.disconnect();
        this.removeEventListener('click', onClick);
        track.removeEventListener('keydown', onKey);
        track.removeEventListener('scroll', onScroll);
      };
    }
    disconnectedCallback() {
      this._cleanup?.();
      this._cleanup = null;
    }
  });
})();
